import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BufferComponent} from './buffer.component';
import {SharedModule} from '../shared/shared.module';
import {TimelineModule} from '../timeline/timeline.module';
import {MatMenuModule} from '@angular/material/menu';
import {ResponsiveComponent} from './responsive/responsive.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    declarations: [
        BufferComponent,
        ResponsiveComponent
    ],
    exports: [
        BufferComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        TimelineModule,
        MatMenuModule,
        TranslateModule.forRoot()
    ]
})
export class BufferModule { }
